<div class="transaction-item bg-neutral-950 rounded-sm">
  <div class="tli-header text-3xl">
    {{ 'internal.events.financeTotal' | translate }}
  </div>

  <span id="tli-amountPending">
    <span class="label">{{'internal.finances.withPending' | translate}}</span>
    @if (total == undefined) {
      <p-skeleton width="9rem" height="2.8125rem" />
    } @else {
      <span class="value" [class.negative]="totalPending < 0">
        {{ totalPending > 0 ? '' : '-' }}
        {{ totalPending.toFixed(2) | mask: 'separator' : { thousandSeparator: ',' } }}€
      </span>
    }
  </span>

  <span id="tli-amount">
    <span class="label">{{'internal.finances.withoutPending' | translate}}</span>
    @if (total == undefined) {
      <p-skeleton width="9rem" height="2.8125rem" />
    } @else {
      <span class="value" [class.negative]="total < 0">
        {{ total > 0 ? '' : '-' }}
        {{ total.toFixed(2) | mask: 'separator' : { thousandSeparator: ',' } }}€
      </span>
    }
  </span>
</div>
